import * as React from "react";
const SVGComponent = ({ color = "#666666", ...props }) => (
  <svg
    width={25}
    height={19}
    viewBox="0 0 25 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.4461 9.41699L21.0745 1.70746C20.7009 0.855013 19.6807 0.1875 18.7503 0.1875H6.25017C5.31978 0.1875 4.29963 0.855013 3.92615 1.70746L0.554148 9.41699C0.244147 10.1277 0 11.2885 0 12.0636V17.0642C0 18.0979 0.840958 18.9389 1.87521 18.9389H23.125C24.159 18.9389 25 18.0979 25 17.0642V12.0636C25 11.2896 24.7585 10.1277 24.4459 9.41699H24.4461ZM5.07092 2.21041C5.24809 1.80617 5.81057 1.43922 6.25026 1.43922H18.7504C19.1897 1.43922 19.7527 1.80655 19.9297 2.21041L23.3016 9.91994C23.3396 10.0057 23.3771 10.1058 23.4138 10.2108C23.3188 10.1956 23.2235 10.1886 23.1257 10.1886H15.6256C15.2811 10.1886 15.0006 10.4696 15.0006 10.8142V11.4392C15.0006 12.8185 13.8799 13.9392 12.5005 13.9392C11.1212 13.9392 10.0004 12.8182 10.0004 11.4392V10.8142C10.0004 10.4696 9.71994 10.1886 9.37543 10.1886H1.87535C1.77777 10.1886 1.68204 10.1958 1.58705 10.2108C1.62379 10.1058 1.66015 10.0058 1.69929 9.91994L5.07092 2.21041Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;